/**
 * FAQs for /compare/jev-vs-llm, exported separately so routes.tsx can build the FAQPage JSON-LD without pulling
 * the page chunk (and its benchmark export) into the route table. No figures here: every number on the page comes
 * from src/data/jev-vs-llm/jev-vs-llm.v1.json through the page's data.ts, and the answers stay true across
 * releases.
 */
export const jevVsLlmFaq: { q: string; a: string }[] = [
  {
    q: 'Why does LangWatch benchmark the model its own product runs on against frontier LLMs?',
    a: 'Instant Evals runs on Jev, and the obvious alternative is to ask a frontier LLM the same question. We wanted to know where that is worth its price. The tie test decides who is ahead on each task, and a task where a frontier LLM beats Jev is shown as such.',
  },
  {
    q: 'Why balanced accuracy on moderation, PII and prompt injection?',
    a: 'The frontier LLMs answer with one label, not a probability, so AUROC and catch rates at a fixed false-alarm rate cannot be computed for them. Every model is compared on balanced accuracy there, computed the same way: Jev at the decision threshold frozen on the dev split, each LLM at its label.',
  },
  {
    q: 'Is the latency comparable?',
    a: 'Among the frontier LLMs that went through the LangWatch AI Gateway, yes: each call was timed from Denmark, several at a time, network included. A model run another way shows no latency, and its footnote says why. Jev’s latency is an approximate server-side time, so it is on another basis and the page names no fastest model across the two.',
  },
  {
    q: 'What does the cost per prompt include?',
    a: 'One prompt is one decision: one call to the model. The cost is the recorded token usage of the test run at each vendor’s public list price, with cached input priced as the provider applied it. A cost marked with a tilde is an estimate, not a recorded cost, and its footnote says how it was made.',
  },
  {
    q: 'What does tied mean?',
    a: 'The paired tie test, run on the same items for every model (an empty answer counts as wrong), cannot separate the two scores: the gap is within what resampling the same items produces. A tied task is neither a win nor a loss for either side.',
  },
  {
    q: 'Are the per-item results published?',
    a: 'No. The page publishes aggregates only: scores with intervals, latency and cost per model and task. We read the per-item results in LangWatch Experiments, one experiment per task with every model as a target; you can set up the same kind of comparison on your own data in a LangWatch project.',
  },
]
